"use client";
import { IBlocks, IUserData } from "@/types";
import React from "react";
import { IconBrandYoutube } from "@tabler/icons-react";
import { Label } from "@/components/ui/label";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import LoadingSkeleton from "@/components/admin/profile/blocks/LoadingSkeleton";
import {
    BORDER_RADIUS_OPTIONS,
    FONT_SIZE_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";
import RenderIconOrAsset from "./utils/RenderIconOrAsset";
import { cn } from "@/lib/utils";
interface Props {
    edit?: boolean;
    block: IBlocks;
    update?: BlockUpdateFunction;
    account: IUserData;
    style: any;
    theme: IUserData["chosen_theme"];
}
export default function BlockYoutube({
    account,
    edit,
    block,
    update,
    style,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`YouTube - ${blockUpdate.url}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            {blockUpdate.options?.hide_offline ? (
                <div className="relative aspect-video w-full min-w-full">
                    <div className={`w-full min-w-full`}>
                        <div
                            className={`absolute flex w-full min-w-full place-content-center items-center justify-center`}
                        >
                            <LoadingSkeleton
                                nopulse
                                className="bg-user-primary-color"
                            />
                            <div className="absolute flex flex-col items-center">
                                <IconBrandYoutube
                                    className="z-50 rounded-md bg-red-500 p-1 shadow-xl"
                                    size={40}
                                />
                                <Label
                                    className="text-user-primary-text-color"
                                    variant="headingtoggle"
                                >
                                    (Preview)
                                </Label>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`w-full`}>
                    <button
                        style={style}
                        id="block"
                        className={cn(
                            "rounded-user bg-user-primary-color text-user-primary-text-color",
                            SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                            blockUpdate.style?.custom &&
                                BORDER_RADIUS_OPTIONS[
                                    blockUpdate.style.corner_radius
                                ]?.class,
                            blockUpdate.style?.custom &&
                                SHADOW_OPTIONS[blockUpdate.style.shadow]?.class,
                            "textsm w-full px-1 py-3 text-xl transition-all duration-150 hover:scale-105",
                            blockUpdate.style?.custom &&
                                FONT_SIZE_OPTIONS[blockUpdate.style.font_size]
                                    ?.class,
                            block.name.replaceAll(" ", "-"),
                            "block-" + block.id
                        )}
                    >
                        <RenderIconOrAsset
                            account_id={account.id}
                            iconName={blockUpdate.icon}
                            size={
                                (blockUpdate.style?.custom &&
                                    FONT_SIZE_OPTIONS[
                                        blockUpdate.style.font_size
                                    ]?.icon) ||
                                FONT_SIZE_OPTIONS[
                                    theme.profile.design.font_size
                                ]?.icon ||
                                26
                            }
                        />
                        <span
                            id="block-text"
                            className={`block w-full px-6 text-center font-bold`}
                        >
                            {blockUpdate.name}
                        </span>
                    </button>
                </div>
            )}
        </AdminPopover>
    );
}
